import React from 'react';
import PropTypes from 'prop-types';

import TicketLogo from '../../nacre/images/weezticket.svg';

import OrganizationInfos from '../../models/organizationInfos';
import Loading from '../../components/loading';
import EventPostCreation from './eventPostCreation';
import EventModel from '../../models/eventModel';
import { ViewPort } from '@weezevent/nacre';
import TopBarModules from '../../components/template/topBarModules/topBarModules';

export default function EventPostCreationContainer({ organization, eventId, history }) {
    const [organizationInfos, loadingOrgaInfos] = OrganizationInfos.useApiModel({
        organizationId: organization.id
    });

    const [event, loadingEvent, , error] = EventModel.useApiModel({
        id: eventId,
        organizationId: organization.id
    });

    if (!loadingEvent && error) {
        return history.replace(`/ticket/O${organization.id}`);
    }

    if (loadingOrgaInfos || loadingEvent) {
        return <Loading />;
    }

    return (
        <ViewPort
            organization={organization}
            logo={TicketLogo}
            onClickLogo={organization && organizationInfos.has_event ? () => history.push(`/ticket/O${organization.pk}`) : null}
            topBarModules={<TopBarModules minimal={!organizationInfos.has_event} organization={organization} />}
        >
            <EventPostCreation organization={organization} organizationInfos={organizationInfos} event={event} />
        </ViewPort>
    );
}

EventPostCreationContainer.propTypes = {
    organization: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    eventId: PropTypes.string.isRequired
};
